export default {
  error: (message, title = null) => {
    return {
      title: title ? title : 'Błąd',
      text: message,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },
  success: (message, title = null) => {
    return {
      title: title ? title : 'Sukces',
      text: message,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'success'
    }
  },
  warning: (message, title = null) => {
    return {
      title: title ? title : 'Uwaga',
      text: message,
      iconPack: 'feather',
      icon: 'icon-info',
      color: 'warning'
    }
  },
}
